import { BitrateLimitationMode, KuxFilteredCategoriesDTO, UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { action } from 'mobx';
import { container } from 'tsyringe';

import { assertPresence, errorHandling } from '../../../../utils/error-handling';
import type { DmsStore } from '../../../dms';
import { SubpageStore } from '../subpage-store';

/**
 * @category Store
 */
export class VideoStore extends SubpageStore {
  static moduleName = 'VideoStore';

  isReady = false;
  subtype: UIDAPresentationTypeEnum.preferred_video_quality = UIDAPresentationTypeEnum.preferred_video_quality;
  bitrateLimits: { title: string; bitrate: number }[];
  userCanToggleMode: boolean;
  bitrateLimitationMode: BitrateLimitationMode;

  private dmsStore: DmsStore;

  constructor(props: KuxFilteredCategoriesDTO, categoryTree: KuxFilteredCategoriesDTO, children?: []) {
    super(props, categoryTree, children);
    this.dmsStore = container.resolve<DmsStore>('dmsStore');
    const dms = assertPresence(this.dmsStore.dms);

    const localVqSettings = this.dmsStore.videoQualitySettings;

    this.bitrateLimits = [
      { title: 'Auto', bitrate: 0 },
      ...localVqSettings.map(([key, value]) => ({
        title: key,
        bitrate: value['top_range_bitrate'],
      })),
    ];
    this.bitrateLimitationMode = dms.bitrateLimitationManagement.bitrateLimitSetBy;
    this.userCanToggleMode = dms.bitrateLimitationManagement.userAllowedTo;
  }

  @action
  @errorHandling()
  async init() {
    super.init();
    this.isReady = true;
  }
}
